import type { FC } from 'react';
import React from 'react';

import FeedbackCollector from '@atlaskit/feedback-collector';

import { useSessionData } from '@confluence/session-data';

const ENTRYPOINT_ID = '53d2d69f-f9a4-4e28-98a1-7dc8a00aebb1';
const FEEDBACK_CONTEXT_ID = 'customfield_10047';

type EditorControlsFeedbackMetadata = {
	location: string; // site name
	userId: string;
	cloudId: string;
	contentId?: string; // do not include key if feedback is not related to a specific page
	edition: string;
	source: string; // where the feedback was triggered from
	environment: string;
	isInternalUser: boolean;
	isLivePage: boolean;
};

export type EditorControlsFeedbackCollectorProps = {
	feedbackTitle: string;
	feedbackTitleDetails: React.ReactChild;
	customTextAreaLabel?: string;
	summaryPlaceholder?: string;
	onClose: () => void;
	onSubmit?: () => void;
	cancelButtonLabel?: string;
	submitButtonLabel?: string;
	source: string;
	contentId?: string;
	isInternalUser: boolean;
	isLivePage: boolean;
};

export const EditorControlsFeedbackCollector: FC<EditorControlsFeedbackCollectorProps> = ({
	feedbackTitle,
	feedbackTitleDetails,
	customTextAreaLabel,
	summaryPlaceholder,
	onClose,
	onSubmit,
	cancelButtonLabel,
	submitButtonLabel,
	source,
	contentId,
	isInternalUser,
	isLivePage,
}) => {
	const { displayName, userId, cloudId, edition, environment } = useSessionData();

	const getFeedbackMetadata = (): string => {
		const feedbackMetadata: EditorControlsFeedbackMetadata = {
			location: window.location.hostname,
			userId: userId ?? '',
			cloudId: cloudId ?? '',
			contentId,
			edition: edition ?? '',
			source,
			environment: environment ?? '',
			isInternalUser,
			isLivePage,
		};

		// format the metadata for better readability in the feedback collector
		return JSON.stringify(feedbackMetadata, null, 2);
	};

	return (
		<FeedbackCollector
			entrypointId={ENTRYPOINT_ID}
			name={displayName ?? undefined}
			atlassianAccountId={userId ?? undefined}
			showTypeField={false}
			feedbackTitle={feedbackTitle}
			feedbackTitleDetails={feedbackTitleDetails}
			additionalFields={[
				{
					id: FEEDBACK_CONTEXT_ID,
					value: getFeedbackMetadata(),
				},
			]}
			customTextAreaLabel={customTextAreaLabel}
			summaryPlaceholder={summaryPlaceholder}
			onClose={onClose}
			onSubmit={onSubmit}
			cancelButtonLabel={cancelButtonLabel}
			submitButtonLabel={submitButtonLabel}
		/>
	);
};
